import React, { useState } from "react";
import styles from "./ListCardFilterBar.module.css";
import { MdExpandLess, MdExpandMore, MdFilterList } from "react-icons/md";
import i18n from "../../Services/i18n";
import DateTimePicker from "../DateTimePicker/DateTimePicker";
const ListCardFilterBar = ({
  type,
  sortKey,
  sortDirection,
  filterText,
  dateFrom,
  dateTo,
  includeArchived,
  searchInTitle,
  searchInDescription,
  onSortChange,
  onFilterChange,
  onIncludeArchived,
  onDateFromChange,
  onDateToChange,
  onSearchInTitleChange,
  onSearchInDescriptionChange,
  onClearFilters,
  displayMode,
  onDisplayModeChange,
  onExpendedChange,
}) => {
  const [expanded, setExpanded] = useState(false);

  const hasActiveFilter =
    !!filterText || !!dateFrom || !!dateTo || !searchInTitle || !searchInDescription;

  const sortOptionsByType = {
    client: ["firstName", "lastName", "createdOn"],
    horse: ["cardName", "createdOn"],
    serviceoccurence: ["dateServiceOccurence"],
    userservice: ["name", "createdOn"],
  };

  const nextDisplayMode = (current) => {
    if (current === "compact") return "normal";
    return "compact";
  };

  const toggleExpanded = () => {
    const next = !expanded;
    setExpanded(next);
    onExpendedChange(next);
  };

  const options = sortOptionsByType[type] || [];

  return (
    <div className={styles.filterBar}>
      <div className={styles.header} onClick={toggleExpanded}>
        <div className={styles.left}>
          <MdFilterList />
          <span>{i18n.t("ListCardContainer.Filter.ShowFilter")}</span>
          {hasActiveFilter && <span className={styles.activeIndicator} />}
        </div>

        <div className={styles.right}>
          <button
            className={styles.displayModeButton}
            onClick={(e) => {
              e.stopPropagation();
              const next = nextDisplayMode(displayMode);
              onDisplayModeChange?.(next);
            }}
            title={i18n.t("ListCardContainer.DisplayMode." + displayMode)}>
            <span className={styles.displayIcon}>
              {displayMode === "compact" && "◻"}
              {displayMode === "normal" && "◼"}
              {displayMode === "expanded" && "⬛"}
            </span>
          </button>

          {hasActiveFilter && (
            <button
              className={styles.clearButton}
              onClick={(e) => {
                e.stopPropagation();
                onClearFilters?.();
              }}>
              {i18n.t("ListCardContainer.Filter.ClearFilter")}
            </button>
          )}

          {expanded ? <MdExpandLess /> : <MdExpandMore />}
        </div>
      </div>

      <div
        className={`${styles.filterBarContent} ${expanded ? styles.filterBarContentExpanded : ""}`}>
        <div className={styles.filterLayout}>
          <div className={styles.filterSection}>
            <div className={styles.sectionLabel}>
              {i18n.t("ListCardContainer.Filter.SearchSection")}
            </div>

            <div className={styles.searchRow}>
              <input
                type="text"
                placeholder={i18n.t("ListCardContainer.Filter.SearchBox")}
                value={filterText}
                onChange={(e) => onFilterChange?.(e.target.value)}
                className={`${styles.input} ${styles.searchInput}`}
              />

              <div className={styles.searchScope}>
                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={searchInTitle}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      if (!checked && !searchInDescription) return;
                      onSearchInTitleChange?.(checked);
                    }}
                  />
                  <span>{i18n.t("ListCardContainer.Filter.SearchInTitle")}</span>
                </label>

                <label className={styles.checkboxLabel}>
                  <input
                    type="checkbox"
                    checked={searchInDescription}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      if (!checked && !searchInTitle) return;
                      onSearchInDescriptionChange?.(checked);
                    }}
                  />
                  <span>{i18n.t("ListCardContainer.Filter.SearchInDescription")}</span>
                </label>
              </div>

              {["client", "horse"].includes(type) && (
                <label className={styles.includeArchived}>
                  <input
                    type="checkbox"
                    checked={includeArchived}
                    onChange={(e) => onIncludeArchived?.(e.target.checked)}
                  />
                  <span>{i18n.t("ListCardContainer.Filter.IncludeArchived")}</span>
                </label>
              )}
            </div>
          </div>

          <div className={styles.lowerRow}>
            <div className={styles.filterSection}>
              <div className={styles.sectionLabel}>
                {i18n.t("ListCardContainer.Filter.SortSection")}
              </div>

              <div className={styles.sortZone}>
                <select
                  value={sortKey}
                  onChange={(e) => {
                    onSortChange?.(e.target.value, sortDirection);
                  }}
                  className={styles.select}>
                  {options.map((opt) => (
                    <option key={opt} value={opt}>
                      {i18n.t("ListCardContainer.Filter.By." + opt)}
                    </option>
                  ))}
                </select>

                <button
                  type="button"
                  className={styles.toggleButton}
                  onClick={() => {
                    onSortChange?.(sortKey, sortDirection === "asc" ? "desc" : "asc");
                  }}
                  title={i18n.t("ListCardContainer.Filter.SortDirection." + sortDirection)}>
                  {sortDirection === "asc" ? "↑" : "↓"}
                </button>
              </div>
            </div>

            <div className={styles.filterSection}>
              <div className={styles.sectionLabel}>
                {i18n.t("ListCardContainer.Filter.DateRangeSection")}
              </div>

              <div className={styles.dateRangeZone}>
                <DateTimePicker
                  value={dateFrom}
                  onChange={onDateFromChange}
                  includeTime={false}
                  placeholder={i18n.t("ListCardContainer.Filter.DateFrom")}
                  maxDate={dateTo ? new Date(dateTo) : undefined}
                />

                <span className={styles.dateSeparator}>→</span>

                <DateTimePicker
                  value={dateTo}
                  onChange={onDateToChange}
                  includeTime={false}
                  placeholder={i18n.t("ListCardContainer.Filter.DateTo")}
                  minDate={dateFrom ? new Date(dateFrom) : undefined}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListCardFilterBar;
